import moment from 'moment';

// The working-day calendar the quantity schedule is spread over.
//
// It has to agree exactly with the API's quantitySpread.js — the grid previews
// a per-day rate and the server stores one, and if the two disagree about how
// many days a span holds, the field report paces against a number the PM never
// saw. Kept here rather than in a page module because every schedule surface
// needs it and no page owns it.

/**
 * Working days between two dates, inclusive of both ends.
 * @param workDays 5 = Mon–Fri, 6 = Mon–Sat (the pipeline default), 7 = calendar.
 */
export const workingDayCount = (start, finish, workDays) => {
    if (!start || !finish) return 0;
    const a = moment(start);
    const b = moment(finish);
    if (!a.isValid() || !b.isValid() || b.isBefore(a)) return 0;
    let count = 0;
    // The 2000-day ceiling stops a typo'd year (2206 for 2026) from spinning.
    for (const d = a.clone(); !d.isAfter(b) && count < 2000; d.add(1, 'day')) {
        const wd = d.day();
        if (workDays >= 7 || (workDays === 6 && wd !== 0) || (workDays === 5 && wd !== 0 && wd !== 6)) count += 1;
    }
    return count;
};

export default workingDayCount;
